var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ebp-dropzone"},[_c('file-pond',_vm._g(_vm._b({ref:"pond",staticClass:"mb-5",attrs:{"fileValidateTypeDetectType":_vm.getCustomMIMEType},on:{"updatefiles":_vm.handle}},'file-pond',_vm.opts,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }